module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.8cac70ebda3f23ce472110d9f21e8593.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/weathericons-regular-webfont.woff
// module id = 267
// module chunks = 0